import styled, { useTheme } from 'styled-components'
import { useWorld } from '../hooks/use-world'
import { Panel as BasePanel } from '../ui'

const Container = styled.div`
  position: absolute;
  top: 1rem;
  left: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  pointer-events: none;
  z-index: 1010;
  max-width: 220px;
`

const QuestPanel = styled(BasePanel)`
  background: ${({ theme }) => theme.colors('background', 0.85)};
  border: 1px solid ${({ theme }) => theme.colors('highlight', 0.3)};
  padding: 0.4rem 0.6rem;
  min-width: unset;
  font-size: 0.6rem;
`

const QuestName = styled.div`
  color: ${({ theme }) => theme.colors('highlight')};
  font-size: 0.62rem;
  margin-bottom: 0.25rem;
`

const Step = styled.div`
  color: ${({ $done, theme }) => $done ? theme.colors('success') : theme.colors('foreground', 0.65)};
  display: flex;
  align-items: flex-start;
  gap: 0.3rem;
  line-height: 1.3;
  text-decoration: ${({ $done }) => $done ? 'line-through' : 'none'};
`

export const QuestHUD = () => {
  const { quests, questProgress } = useWorld()

  const active = quests.filter(q => questProgress[q.id]?.status === 'active')
  if (!active.length) return null

  return (
    <Container>
      {active.map(quest => {
        const progress = questProgress[quest.id]
        return (
          <QuestPanel key={quest.id}>
            <QuestName>{quest.name}</QuestName>
            {quest.steps.map(step => {
              const done = progress.completedSteps.includes(step.id)
              return (
                <Step key={step.id} $done={done}>
                  <span>{done ? '✓' : '·'}</span>
                  <span>{step.description}</span>
                </Step>
              )
            })}
          </QuestPanel>
        )
      })}
    </Container>
  )
}
